import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { ALL_AOLS, AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { CURRENT_AWARENESS, DASHBOARD } from 'constants/controllers'
import NewsTickerContainer from 'redux/containers/pages/dashboard/NewsTickerContainer'
import { selectPrimaryAol } from 'redux/selectors/selectPrimaryAol'
import { setNewsAol } from 'redux/actions'
import AOLDropdown from 'components/shared/AOLDropdown'

const DashboardHeader = ({ aol }) => {
  const caUrl = url(CURRENT_AWARENESS, { aol })

  const dispatch = useDispatch()

  const handleOnSelectAol = (newAol) => {
    dispatch(setNewsAol(newAol.urlFragment))
    replaceUrl(url(DASHBOARD, { aol: newAol.urlFragment }))
  }

  const placeholderAol = AOL_DISPLAY_NAMES[useSelector(selectPrimaryAol)] || 'Corporate'

  return (
    <div className='bg-white shadow-1 layout-width-constraint'>
      <div className='flex min-h3 pb4 pb0-t flex-column-reverse-t justify-between items-center items-stretch-t'>
        <div className='flex grow-0 shrink-0 items-center mt6-t'>
          <AOLDropdown
            handleOnSelect={handleOnSelectAol}
            selected={AOL_DISPLAY_NAMES[aol]}
            label={AOL_DISPLAY_NAMES[aol] || placeholderAol}
            options={ALL_AOLS.map(aol => ({ label: AOL_DISPLAY_NAMES[aol], href: aol }))}
            align='right'
          />
          <h4 className='black b f3 mv0 ml4 ml6-m mr6 grow-0 shrink-0'>Latest News</h4>
          <a href={caUrl} className='dib f7 mt4 pointer no-underline hover-underline'>View all News</a>
        </div>
        <div className='basis0 grow-1 shrink-1 h3 min-h2 max-h8-t ml6 -mb4 ml0-t pv2 pv0-t'>
          <NewsTickerContainer aol={aol} />
        </div>
      </div>
    </div>
  )
}

export default DashboardHeader
